/**
 * 예약 패널(DdukdocReservationPanel)의 순수 helper. 컴포넌트 밖에 두어 spec으로 고정한다.
 * DDukDoc `apps/booking/app/api/v1/chat/chat-dashboard/reservations` 창구와 짝이다.
 */

/**
 * 신청의 희망 시술 문구로 시술 목록에서 기본 선택을 고른다.
 * 정확 일치 → 포함 → 같은 카테고리 첫 항목 → 첫 항목. 목록이 비면 ''.
 */
export function pickDefaultTreatmentId(request, treatments) {
  if (!Array.isArray(treatments) || treatments.length === 0) return '';
  const hint = (request?.procedureHint || '').trim();
  if (hint) {
    const exact = treatments.find(t => (t.name || '').trim() === hint);
    if (exact) return exact.id;
    const partial = treatments.find(
      t => (t.name || '').includes(hint) || hint.includes((t.name || '').trim())
    );
    if (partial) return partial.id;
  }
  if (request?.treatmentCategoryId) {
    const sameCategory = treatments.find(
      t => t.categoryId === request.treatmentCategoryId
    );
    if (sameCategory) return sameCategory.id;
  }
  return treatments[0].id;
}

/** YYYY-MM-DD 문자열에 일 단위 더하기(달력 산술은 UTC로 해서 DST/로컬 시간대 영향 없음). */
export function shiftDate(date, days) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date || '');
  if (!m) return date;
  const t = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]) + days);
  return new Date(t).toISOString().slice(0, 10);
}

/** 결정 응답을 상담원이 읽을 한 줄로. 내부 코드는 여기서 문장으로 바꾼다. */
export function describeDecisionResult(result, t) {
  if (!result || !result.ok) {
    const code = result && result.code;
    if (code === 'staff_not_linked') return t('HOSPITAL.RESERVATIONS.ERR_STAFF_NOT_LINKED');
    if (code === 'slot_full') return t('HOSPITAL.RESERVATIONS.ERR_SLOT_FULL');
    if (code === 'treatment_required' || code === 'treatment_invalid')
      return t('HOSPITAL.RESERVATIONS.ERR_TREATMENT');
    if (code === 'already_decided') return t('HOSPITAL.RESERVATIONS.ERR_ALREADY');
    return t('HOSPITAL.RESERVATIONS.ERR_GENERIC');
  }
  const parts = [];
  if (result.action === 'approve') {
    parts.push(t('HOSPITAL.RESERVATIONS.APPROVED'));
    if (result.emr === 'failed') parts.push(result.emrMessage || t('HOSPITAL.RESERVATIONS.EMR_FAILED'));
    else if (result.emr === 'skipped' && result.emrMessage) parts.push(result.emrMessage);
  } else {
    parts.push(t('HOSPITAL.RESERVATIONS.REJECTED'));
  }
  parts.push(
    result.replied
      ? t('HOSPITAL.RESERVATIONS.REPLIED')
      : t('HOSPITAL.RESERVATIONS.REPLY_FAILED')
  );
  return parts.join(' ');
}

/** 예약 현황 한 줄의 상태 라벨 키. 벤더 status 원문을 화면에 그대로 내지 않는다. */
export function statusLabelKey(status) {
  const s = String(status || '').toUpperCase();
  if (s === 'REQUESTED') return 'HOSPITAL.RESERVATIONS.STATUS_REQUESTED';
  if (s.includes('CANCEL')) return 'HOSPITAL.RESERVATIONS.STATUS_CANCELLED';
  if (s.includes('NO_SHOW') || s.includes('NOSHOW')) return 'HOSPITAL.RESERVATIONS.STATUS_NO_SHOW';
  if (s.includes('COMPLETE') || s.includes('ENCOUNTER')) return 'HOSPITAL.RESERVATIONS.STATUS_DONE';
  return 'HOSPITAL.RESERVATIONS.STATUS_CONFIRMED';
}
